import React, { useState, useEffect } from "react";
import { Button } from "antd";
import "antd/dist/reset.css";
import Ecommerce from "../composant/Ecommerce";
import Footer from "../composant/Footer";
import MyLoader from "../composant/MyLoader";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigation = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  const scrollToMenu = () => {
    const section = document.getElementById("menu-section");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  if (loading) return <MyLoader />;

  return (
    <div>
      <style>{`
        :root {
          --primary-color: #edbb05;
          --text-dark: #1f2937;
          --text-light: #4b5563;
        }

        .hero {
          min-height: 90vh;
          display: flex;
          align-items: center;
          position: relative;
          overflow: hidden;
          padding: 60px 5%;
          background: linear-gradient(135deg, #fffcf0 0%, #fef3c7 100%);
          font-family: 'Inter', -apple-system, sans-serif;
        }

        /* Décoration d'arrière-plan */
        .hero::before {
          content: "";
          position: absolute;
          top: -10%;
          right: -5%;
          width: 400px;
          height: 400px;
          background: rgba(237, 187, 5, 0.1);
          border-radius: 50%;
          filter: blur(80px);
        }

        .hero-container {
          max-width: 1200px;
          margin: auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 60px;
          z-index: 2;
        }

        .hero-left {
          flex: 1;
          animation: fadeInUp 0.8s ease-out;
        }

        .hero-title {
          font-size: clamp(40px, 6vw, 72px);
          font-weight: 900;
          line-height: 1.1;
          color: var(--text-dark);
          margin-bottom: 24px;
          letter-spacing: -0.02em;
        }

        .hero-title span {
          color: var(--primary-color);
          background: linear-gradient(90deg, #edbb05, #f59e0b);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .hero-description {
          font-size: clamp(18px, 2vw, 22px);
          color: var(--text-light);
          line-height: 1.6;
          margin-bottom: 32px;
          max-width: 500px;
        }

        .hero-info {
          display: inline-block;
          padding: 8px 16px;
          background: white;
          border-radius: 50px;
          font-weight: 600;
          font-size: 14px;
          color: var(--text-dark);
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          margin-bottom: 32px;
        }

        .hero-buttons {
          display: flex;
          gap: 20px;
          flex-wrap: wrap;
        }

        .btn-modern {
          height: 56px !important;
          padding: 0 32px !important;
          border-radius: 14px !important;
          font-weight: 700 !important;
          font-size: 16px !important;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
          display: flex;
          align-items: center;
        }

        .btn-primary {
          background-color: var(--primary-color) !important;
          border: none !important;
          color: #fff !important;
          box-shadow: 0 10px 20px rgba(237, 187, 5, 0.3) !important;
        }

        .btn-primary:hover {
          transform: translateY(-3px);
          box-shadow: 0 15px 25px rgba(237, 187, 5, 0.4) !important;
          background-color: #d9ab04 !important;
        }

        .btn-secondary {
          border: 2px solid #e5e7eb !important;
          background: transparent !important;
          color: var(--text-dark) !important;
        }

        .btn-secondary:hover {
          border-color: var(--primary-color) !important;
          color: var(--primary-color) !important;
          background: white !important;
        }

        .hero-right {
          flex: 1;
          display: flex;
          justify-content: center;
          animation: float 6s ease-in-out infinite;
        }

        .hero-right img {
          width: 100%;
          max-width: 550px;
          filter: drop-shadow(20px 30px 50px rgba(0,0,0,0.15));
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }

        @media (max-width: 992px) {
          .hero-container {
            flex-direction: column;
            text-align: center;
            padding-top: 40px;
          }
          .hero-left {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .hero-buttons {
            justify-content: center;
          }
          .hero-right img {
            max-width: 400px;
          }
        }
      `}</style>

      <section className="hero">
        <div className="hero-container">
          <div className="hero-left">
            <div className="hero-info">
              Livraison rapide • Paiement à la réception
            </div>
            
            <h1 className="hero-title">
              Savourez l'instant avec <span>Resto Sadem</span>
            </h1>

            <p className="hero-description">
              Le meilleur de la gastronomie livré chez vous. Commandez vos plats préférés en quelques secondes.
            </p>

            <div className="hero-buttons">
              <Button 
                type="primary" 
                className="btn-modern btn-primary" 
                onClick={scrollToMenu}
              >
                Commander maintenant
              </Button>

              <Button 
                className="btn-modern btn-secondary" 
                onClick={() => navigation("/menu")}
              >
                Explorer le menu
              </Button>
            </div>
          </div>

          <div className="hero-right">
            <img src="/burger.png" alt="Plat signature" />
          </div>
        </div>
      </section>

      <div id="menu-section">
        <Ecommerce />
      </div>

      <Footer />
    </div>
  );
};

export default Hero;